import { ReactNode, useState } from 'react'
import Sidebar from '../admin/Sidebar'
import UserNav from '../admin/UserNav'
import { Menu, X } from 'lucide-react'
import { Button } from '../ui/button'

interface AdminLayoutProps {
  children: ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="border-b bg-gradient-to-r from-blue-600 to-indigo-700 text-white sticky top-0 z-50">
        <div className="flex h-16 items-center px-4">
          <button 
            className="mr-2 md:hidden" 
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <Menu className="h-6 w-6" />
          </button>
          <div className="text-xl font-bold">Hydralyfe Admin</div>
          <div className="ml-auto flex items-center space-x-4">
            <UserNav />
          </div>
        </div>
      </div>
      
      <div className="flex-1 bg-gray-50">
        <div className="flex min-h-screen bg-gray-100">
          {/* Mobile Sidebar Overlay */}
          {isSidebarOpen && (
            <div 
              className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
              onClick={() => setIsSidebarOpen(false)}
            />
          )}
          
          {/* Sidebar */}
          <div className={`
            fixed md:static h-full bg-white border-r shadow-sm z-50
            ${isSidebarOpen ? 'block' : 'hidden'} md:block
            w-64 transition-all duration-300 ease-in-out
          `}>
            <div className="flex justify-between items-center p-4 md:hidden">
              <h2 className="font-bold">Menu</h2>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => setIsSidebarOpen(false)}
              >
                <X className="h-5 w-5" />
              </Button>
            </div>
            <Sidebar />
          </div>
          
          {/* Main Content */}
          <main className={`
            flex-1 overflow-y-auto w-full
            md:ml-64 transition-all duration-300
          `}>
            {children}
          </main>
        </div>
      </div>
    </div>
  )
} 